import React from "react";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CropFreeIcon from "@material-ui/icons/CropFree";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixHeaderProps } from "../types";

const PixHeader: React.FC<PixHeaderProps> = ({ paymentStatus, onClose }) => {
  const classes = usePixModalStyles();
  const isPending = paymentStatus === "pending";

  return (
    <div
      className={`${classes.header} ${
        isPending ? classes.headerPending : classes.headerConfirmed
      }`}
    >
      <div
        className={`${classes.headerIcon} ${
          isPending ? classes.headerIconPending : classes.headerIconConfirmed
        }`}
      >
        {isPending ? (
          <CropFreeIcon fontSize="small" />
        ) : (
          <CheckCircleIcon fontSize="small" />
        )}
      </div>

      <div className={classes.headerTextWrapper}>
        <h4 className={classes.headerTitle}>
          {isPending ? "Pagamento via Pix" : "Pagamento Confirmado"}
        </h4>
        <span className={classes.headerSubtitle}>
          {isPending
            ? "Rápido, seguro e sem taxas"
            : "Pedido liberado para entrega"}
        </span>
      </div>

      <span
        className={`${classes.badge} ${
          isPending ? classes.badgePending : classes.badgeConfirmed
        }`}
      >
        {isPending ? "• Aguardando pagamento" : "• Pagamento confirmado"}
      </span>

      <IconButton
        size="small"
        className={classes.closeButton}
        onClick={onClose}
        aria-label="Fechar modal"
      >
        <CloseIcon style={{ fontSize: 14 }} />
      </IconButton>
    </div>
  );
};

export default PixHeader;
